module.exports = __webpack_public_path__ + "media/images/smiley-board-director-f2d498de93e5747688961fe977623409.png";